module.exports = __webpack_public_path__ + "img/img-empty.b8ee79d2.png";